import { render } from "./advisorResultCta.vue?vue&type=template&id=58fff78a&scoped=true&ts=true"
import script from "./advisorResultCta.vue?vue&type=script&lang=ts"
export * from "./advisorResultCta.vue?vue&type=script&lang=ts"

import "./advisorResultCta.vue?vue&type=style&index=0&id=58fff78a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fff78a"]])

export default __exports__